<template>
  <div>
    <v-dialog v-model="loadingGeo" hide-overlay persistent width="300">
      <v-card>
        <v-card-text class="py-3 py-md-5">
          <span class="font-weight-bold">Localizando tu dirección</span>
          <v-progress-linear indeterminate color="black" class="mb-0 mt-0 mt-md-2"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-col
      class="px-0 py-4 py-md-10"
      xs="12"
      offset-xs="0"
      sm="10"
      offset-sm="1"
      md="8"
      offset-md="2"
    >
      <v-combobox
        :menu-props="{ auto: false, maxHeight: 270 }"
        clearable
        hide-details
        outlined
        persistent-hint
        solo
        auto-select-first
        ref="inputLocalizacion"
        v-model="textoInput"
        :items="locationEntries"
        :search-input.sync="locationSearchText"
        :loading="loadingInput"
        :disabled="loadingInput"
        no-filter
        item-text="value"
        item-value="id"
        hide-no-data
        return-object
        error-messages
        :label="$t('pedido.modo.inputlocalizacion.textField1.label.introduce')"
        append-icon="mdi-magnify"
        @click:append="localizarTextoInput($event)"
        @input="localizarTextoInput($event)"
        @focus="inputFocus()"
      ></v-combobox>
    </v-col>
    <dialogDireccion />
  </div>
</template>

<script>
import { GetSuggestions } from "@/utils/PlaceUtils";
import { mapState, mapActions } from "vuex";
import dialogDireccion from "@/components/Pedidos/pedir_dialogDireccion.vue";

export default {
  name: "input-localizacion",
  props: {
    modo: String
  },
  components: {
    dialogDireccion
  },
  data() {
    return {};
  },
  mounted() {
    let _vue = this;
    if (this.$store.state.app.cargadoComponenteApp) {
      this.cargarLogica();
    } else {
      this.unwatch = this.$store.watch(
        state => state.app.cargadoComponenteApp,
        (newValue, oldValue) => {
          // Do whatever makes sense now
          if (newValue) {
            this.cargarLogica();
            this.unwatch();
          }
        }
      );
    }
    //this.cargarLogica();
  },
  computed: {
    textoInput: {
      get() {
        switch (this.modo) {
          case "recoger":
            return this.$store.state.direcciones.dirRecogerInput;
            break;
          case "domicilio":
            return this.$store.state.direcciones.dirDomicilioInput;
            break;
        }
      },
      set(v) {
        console.log(v);
        switch (this.modo) {
          case "recoger":
            this.$store.commit("direcciones/setDirRecogerInput", v);
            break;
          case "domicilio":
            this.$store.commit("direcciones/setDirDomicilioInput", v);
            break;
        }
      }
    },

    //nuevo
    ...mapState({
      loadingGeo: state => state.direcciones.loadingGeo,
      loadingInput: state => state.direcciones.loadingInput,
      listadoRestaurantes: state => state.pedido.listadoRestaurantes,
      navigatorAddress: state => state.pedido.navigatorAddress,
      addressObject: state => state.pedido.addressObject,
      codigoProvincia: state => state.pedido.addressObject.codigoProvincia,
      isLogged: state => state.auth.isLogged,
      direcciones: state => state.direcciones.direcciones,
      dirPidiendo: state => state.direcciones.dirPidiendo,
      dirInput: state => state.direcciones.direccionInput,
      loadingDialog: state => state.pedido.loadingDialog,
      loadingDireccionNavegador: state =>
        state.direcciones.loadingDireccionNavegador,
      isMobile: state => state.app.isMobile,
      isSafari: state => state.app.isSafari
    }),
    locationSearchText: {
      get() {
        return this.$store.state.direcciones.locationSearchText;
      },
      set(v) {
        this.$store.commit("direcciones/setLocationSearchText", v);
      }
    },
    locationEntries: {
      get() {
        return this.$store.state.direcciones.locationEntries;
      },
      set(v) {
        this.$store.commit("direcciones/setLocationEntries", v);
      }
    },
    buscando: {
      get() {
        return this.$store.state.direcciones.buscando;
      },
      set(v) {
        this.$store.commit("direcciones/setBuscando", v);
      }
    },
    dialogDireccion: {
      get() {
        return this.$store.state.pedido.dialogDireccion;
      },
      set(value) {
        this.$store.commit("pedido/setDialogDireccion", value);
      }
    },
    direccionCache: {
      get() {
        return this.$store.state.direcciones.direccionCache;
      },
      set(value) {
        this.$store.commit("direcciones/setDireccionCache", value);
      }
    },
    loadingRest: {
      get() {
        return this.$store.state.restaurante.loadingRest;
      },
      set(value) {
        this.$store.commit("restaurante/setLoadingRest", value);
      }
    },
    checkEveryLoading() {
      let res =
        this.loadingRest ||
        this.loadingDireccionNavegador ||
        this.loadingDialog;

      return res;
    }
  },
  watch: {
    locationSearchText(newVal) {
      var _vue = this;
      // If less than 3 chars typed, do not search
      if (!newVal || newVal.length <= 4) {
        this.locationEntries = [];
        return;
      }

      // Call the method from the previous section here
      GetSuggestions(newVal)
        .then(function(res) {
          if (res != "ZERO_RESULTS") {
            _vue.locationEntries = res;
          } else {
            if (_vue.modo == "domicilio") {
              _vue.locationEntries = [
                { value: "No se localiza. Escribir a mano." }
              ];
            } else {
            }
          }
        })
        .catch(function(err) {
          // error handling goes here
        })
        .finally(function() {});
    },
    direcciones(newVal, oldVal) {
      if (oldVal.length != newVal.length) {
        //Carga si hay direcciones diferentes
        this.cargarDireccionesUsuario();
      }
    }
  },
  methods: {
    localizarTextoInput() {
      console.log(this.textoInput);
      this.localizarTextoInputAction(this.textoInput);
    },
    ...mapActions({
      localizarTextoInputAction: "direcciones/localizarTextoInput"
    }),
    //nuevo
    ...mapActions({
      cargarLogicaRecoger: "direcciones/cargarLogicaRecoger",
      cargarLogicaDomicilio: "direcciones/cargarLogicaDomicilio",
      openDialogDireccion: "direcciones/openDialogDireccion",
      loadAndOrderRestaurants: "direcciones/loadAndOrderRestaurants",
      geocodeAddress: "direcciones/geocodeInput", //este vale
      getNavigatorLocation: "direcciones/getNavigatorLocation"
    }),
    inputFocus() {
      let _vue = this;
      let duration = _vue.isSafari ? 0 : 500;
      let offset = _vue.isMobile ? 50 : 0;

      this.$vuetify.goTo(this.$refs.inputLocalizacion.$el, {
        duration: duration,
        offset: offset,
        easing: "easeOutQuad"
      });
    },
    keyEnter() {
      console.log(this.locationEntries);
      if (this.locationEntries.length == 0) {
        //se ha pulsado sin sugerencias
        //this.localizarTextoInput();
      } else {
        //this.textoInput = this.locationEntries[0];
        console.log("antes");
        //this.localizarTextoInput();
        //this.locationEntries = [];
      }
    },

    addressExists() {
      this.$emit("update", true);
    },

    cargarLogica() {
      let _vue = this;
      switch (this.modo) {
        case "recoger":
          _vue.cargarLogicaRecoger().then(function(e) {});

          break;
        case "domicilio":
          _vue.cargarLogicaDomicilio().then(function(e) {});

          break;
        default:
          console.log("Caso no controlado");
          break;
      }
    },
    cargarDireccionesUsuario() {
      //Trata de cargar las direcciones del usuario, si hay problemas prueba los otro métodos
      let _vue = this;
      let coordenadas;

      this.direcciones.forEach(function(e) {
        if (e.predeterminada) {
          coordenadas = e.coordenadas.split(",");
        }
      });
      if (coordenadas) {
        _vue.$store.commit("pedido/setNavigatorLocation", coordenadas);
        this.loadAndOrderRestaurants();
      } else if (Object.entries(this.direccionCache).length > 0) {
        this.loadLocalAddress();
      } else {
        this.getNavigatorLocation();
      }
    },
    loadLocalAddress() {
      this.$store.commit(
        "pedido/setAddressObjectSinFiltro",
        this.direccionCache
      );

      this.loadAndOrderRestaurants();
    }
  }
};
</script>
<style scoped>
.border {
  border: 1px solid #000;
}
</style>